import { useState } from 'react';
import { toast } from 'react-hot-toast';
import DialogShell from '../../components/DialogShell';
import { deleteSubscription, updateSubscription } from '../../services';

function getErrorMessage(error) {
  return error.response?.data?.error || error.response?.data?.message || error.message || 'Request failed';
}

export default function EditSubscriptionDialog({ subscription, onClose, onUpdated, onDeleted }) {
  const [requestsLimit, setRequestsLimit] = useState(subscription.requests_limit);
  const [requestsUsed, setRequestsUsed] = useState(subscription.requests_used);
  const [concurrency, setConcurrency] = useState(subscription.concurrency);
  const [note, setNote] = useState(subscription.note || '');
  const [isActive, setIsActive] = useState(!!subscription.is_active);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const updated = await updateSubscription(subscription.id, {
        requests_limit: Number(requestsLimit),
        requests_used: Number(requestsUsed),
        concurrency: Number(concurrency),
        note,
        is_active: isActive ? 1 : 0,
      });
      toast.success('Đã cập nhật subscription.');
      onUpdated(updated);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  }

  async function handleDelete() {
    setIsDeleting(true);
    try {
      await deleteSubscription(subscription.id);
      toast.success('Đã xoá subscription.');
      onDeleted(subscription.id);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsDeleting(false);
    }
  }

  return (
    <DialogShell onClose={onClose}>
      <h4 className="text-lg font-semibold text-slate-900">Sửa subscription #{subscription.id}</h4>
      <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs text-slate-500">Requests limit</label>
            <input
              type="number"
              value={requestsLimit}
              onChange={(event) => setRequestsLimit(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
          <div>
            <label className="text-xs text-slate-500">Requests used</label>
            <input
              type="number"
              value={requestsUsed}
              onChange={(event) => setRequestsUsed(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
          <div>
            <label className="text-xs text-slate-500">Concurrency</label>
            <input
              type="number"
              value={concurrency}
              onChange={(event) => setConcurrency(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
        </div>

        <div>
          <label className="text-xs text-slate-500">Ghi chú</label>
          <input
            value={note}
            onChange={(event) => setNote(event.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
          />
        </div>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input type="checkbox" checked={isActive} onChange={(event) => setIsActive(event.target.checked)} />
          Active
        </label>

        <div className="mt-5 flex items-center justify-between gap-2">
          <button
            type="button"
            onClick={handleDelete}
            disabled={isDeleting}
            className="rounded-lg border border-red-200 px-4 py-2 text-sm text-red-600 disabled:opacity-60"
          >
            {isDeleting ? 'Đang xoá...' : 'Xoá'}
          </button>
          <div className="flex gap-2">
            <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700">
              Hủy
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
            >
              {isSubmitting ? 'Đang lưu...' : 'Lưu'}
            </button>
          </div>
        </div>
      </form>
    </DialogShell>
  );
}
